import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';

import axios from 'axios';
import apiUrl from '../constants.js';
import history from '../history';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  root: {
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2),
  },
},
}));

export default function SignIn() {
  const classes = useStyles();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("ok");

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  console.log("token: "+token);

  if(token && userId){
    history.push(process.env.REACT_APP_PREFIX_DIR+'/dashboard');
  }

  const handleClose = (event, reason) => {
     if (reason === 'clickaway') {
       return;
     }
     setOpen(false);
  };

  const showAlert = (message) => {
    setMessage(message);
    setOpen(true);

    setTimeout(function(){
      setOpen(false);
    }, 3000);

  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let data = JSON.stringify({
        email: email,
        password: password
    })

    setLoading(true);

    axios.post(apiUrl+'v1/admin/login', data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      }
    )
    .then(function (response) {
      console.log(response);

      setLoading(false);

      if(!response.data.success){
        showAlert(response.data.message);
        return;
      }

      localStorage.setItem('user_id', response.data.user.id)
      localStorage.setItem('token', response.data.session.mobile_token)
      history.push(process.env.REACT_APP_PREFIX_DIR+'/dashboard');
    })
    .catch(function (error) {
      let msg = "Ha ocurrido un error al intentar realizar esta consulta, por favor intente de nuevo más tarde";
      setLoading(false);
      showAlert(msg);
    });
  }

  return (
    <MuiThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
        <CssBaseline />
        <div className={classes.paper}>

          <img
            src={process.env.REACT_APP_PREFIX_DIR+"/img/logo.png"}
            alt="MAX Delivery Logo"
            className="img-logo-login"
            />

          <form className={classes.form} onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo electrónico"
              name="email"
              type="email"
              autoComplete="email"
              disabled={loading}
              onChange={ e => setEmail(e.target.value) }
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              disabled={loading}
              onChange={ e => setPassword(e.target.value) }
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={loading}
              className={classes.submit}
            >
              Ingresar
            </Button>
          </form>
        </div>
      </Container>
    </MuiThemeProvider>
  );
}
